import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { ChoiceType } from 'types/bread'

type Props = {
  choices: ChoiceType[]
}

const OrderBreadOptionList: FC<Props> = (props) => {
  const { choices } = props

  return (
    <>
      {choices.map((choice) => (
        <div className={styles.order__accordion} key={choice.choice}>
          <span className={styles.order__accordion__cell__header}>
            └&nbsp;{choice.choice !== '' ? choice.choice : 'オプションなし'}
          </span>
          <span className={styles.order__accordion__cell}>{choice.quantity}</span>
        </div>
      ))}
    </>
  )
}

export default OrderBreadOptionList
